import apiFetch from '../apiFetch'

export default function (idUbicacionVerraco, token) {
  return apiFetch({endPoint: `MovimientoVerraco/eliminarVerraco?idUbicacionVerraco=` + idUbicacionVerraco, method: 'GET', body: null, token: token})
}